<template>
    <div
        class="tab-panel"
        role="tabPanel"
    >
        <div class="tab-content">
            <slot />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    // TODO: Should fix below so it doesn't clash with HTML elements
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Tab',
    props: [
        'title', 'titleSlot', 'disabled'
    ]
});
</script>

<style lang="scss">
.tab-panel {
  .tab-content {
    padding: 0.5rem;
  }
}
</style>
